import './Tab.scss';

import * as React from 'react';
import { ComponentProps } from 'react';

import { SlTab } from '@shoelace-style/shoelace/dist/react';
import cx from 'classnames';

export type TabProps = ComponentProps<typeof SlTab>;

/*
 * This component is a wrapper around the SlTab component.
 * It adds a class to the SlTab component and passes through the rest of the props.
 */
export function Tab({ children, className, ...props }: TabProps) {
  const classes = cx('socrative-tab', className);

  return (
    <SlTab {...props} className={classes}>
      {children}
    </SlTab>
  );
}
  